import { render, staticRenderFns } from "./AbsenceJustifiedWidget.vue?vue&type=template&id=e66dc960&scoped=true&"
import script from "./AbsenceJustifiedWidget.vue?vue&type=script&lang=js&"
export * from "./AbsenceJustifiedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66dc960",
  null
  
)

export default component.exports